import { useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Legend } from '../../../../../common/chart/legend'
import { PieChartContainer } from '../../../../../common/chart/pieChart'
import { Notification } from '../../../../../common/notification'
import { getUnique } from '../../../../../helpers/common'
import { TranslateCompanies } from '../../../../common/text/TranslateCustom'
import { TYPE_SCORE } from '../../constants'
import {
  selectCreditRiskScore,
  selectPerformanceScore,
} from '../../store/slice'

export const PieChartScore = ({ type }) => {
  const chartId = useRef(getUnique())
  const dataCredit = useSelector(selectCreditRiskScore('data'))
  const dataPerformance = useSelector(selectPerformanceScore('data'))

  const data = useMemo(() => {
    if (type === TYPE_SCORE.CREDIT) return dataCredit
    if (type === TYPE_SCORE.PERFORMANCE) return dataPerformance
  }, [type])

  const legendItems = data.map((item, index) => ({
    title: item.name || '',
    value: item.value,
    color: item?.color || '#BCBCBC',
    pieIndex: index,
  }))

  //Actions
  const formatValueTooltip = (_, { activeData }) => {
    return `${activeData.value} | ${activeData.percent}%`
  }

  if (type === TYPE_SCORE.CREDIT && !dataCredit.length) {
    return (
      <div className="dFlex w100 justifyContentCenter">
        <Notification />
      </div>
    )
  }
  if (type === TYPE_SCORE.PERFORMANCE && !dataPerformance.length) {
    return (
      <div className="dFlex w100 justifyContentCenter">
        <Notification />
      </div>
    )
  }

  return (
    <div className="dFlex gap2 w100">
      <div style={{ minWidth: 130 }} className="w40 dFlex justifyContentEnd">
        <PieChartContainer
          chartId={chartId.current}
          data={data}
          width={130}
          height={130}
          innerRadius={34}
          isTooltipActive={true}
          formatValueTooltip={formatValueTooltip}
          isLabelActive={false}
          labelCenter={{
            customLabel: () => <TranslateCompanies count={data[0]?.total} />,
            outerRadius: 35,
            style: {
              fontSize: 11,
              textTransform: 'capitalize',
              color: '#3A414B',
              alignItems: 'center',
              marginTop: -4,
            },
          }}
        />
      </div>
      <div style={{ paddingTop: 8 }} className="flex1">
        <Legend
          chartId={chartId.current}
          items={legendItems}
          className="flexColumn"
        />
      </div>
    </div>
  )
}
